// extracted by mini-css-extract-plugin
export default {"blank":"SubPage_blank__06j8I"};